<div class="flex justify-left pl-4 mb-4">
  <h1>Inspections</h1>
</div>
<lib-ui-grid class="mt-4" [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
